export const RECEIVE_SLACK_CHANNELS = "slackIntegration/RECEIVE_SLACK_CHANNELS";
